"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("slick-carousel");
require('./../scss/sites/cult/cult.scss');
const index_1 = require("./index");
const cult_1 = require("./Sites/cult");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import site specific scripts
(0, cult_1.InitCult)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
